/**
 * 自訂文本最大字數
 */
export const CUSTOM_TEXT_MAX_LENGTH = 500;

/**
 * AI 素養題生成最大使用次數
 */
export const AI_QUESTION_GENERATION_MAX_COUNT = 50;

/**
 * AI 素養題生成重試最大次數
 */
export const GENERATION_TRY_MAX_COUNT = 3;

/**
 * AI 素養題生成格式
 */
export const GENERATION_FORMAT = {
  QUESTION_GROUP_COUNT: 3, // 題組數量
  SUB_QUESTION_COUNT: 3, // 每個題組的子題數量
  SUB_QUESTION_MULTIPLE_CHOICE_COUNT: 3, // 每個題組的單選題子題數量
  MULTIPLE_CHOICE_OPTION_COUNT: 4, // 單選題選項數量
} as const;

/**
 * 生成步驟
 */
export const GENERATION_STEP = {
  SELECT: "select",
  GENERATING: "generating",
  RESULT: "result",
} as const;

/**
 * 題目類型（選擇題或開放式問答題）
 */
export const QUESTION_TYPE = {
  MULTIPLE_CHOICE: "multiple_choice",
  OPEN_ENDED: "open_ended",
} as const;

export const EDU = {
  E: "E",
  J: "J",
  H: "H",
} as const;

/**
 * 數字圈碼
 */
export const CIRCLED_LABELS = [
  "①",
  "②",
  "③",
  "④",
  "⑤",
  "⑥",
  "⑦",
  "⑧",
  "⑨",
  "⑩",
] as const;

/**
 * 字母編號
 */
export const ALPHABET_LABELS = [
  "(A)",
  "(B)",
  "(C)",
  "(D)",
  "(E)",
  "(F)",
  "(G)",
  "(H)",
  "(I)",
  "(J)",
] as const;

export const LABELS_BY_EDU = {
  [EDU.E]: CIRCLED_LABELS,
  [EDU.J]: ALPHABET_LABELS,
  [EDU.H]: ALPHABET_LABELS,
};

export const CLARITY_PROJECT_MAP: Record<string, string> = {
  "coretest.oneclass.com.tw": "vm6e67enb9",
  "coretest.nani.com.tw": "vm6dx9pdgj",
};

export const IS_ENABLE_GENERATION_COUNT_LIMIT = true;
